import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Layout from "./Components/Layout";
import Projects from "./Components/Projects";
import Quotes from "./Components/Quotes";
import Weatherman from "./Components/Weatherman";
import ErrorPage from './Components/ErrorPage'
import MovieDB from "./Components/MovieDatabase/MovieDB";
import TextUtils from "./Components/TextUtils";
import About from "./Components/About";
import UsesByGRohit from "./Components/UsesByGRohit";
import Contact from "./Components/Contact";
import ScrollToTop from "./Components/ScrollToTop";
import MouseTrail from "./Components/MouseTrail";

function App() {
  return (
    <>
      <Router>
         <ScrollToTop/> 
          <MouseTrail/>
        <Routes>
          {/* Main Layout */}
          <Route index element={<Layout />} />
          {/* All routings */}
          <Route path="/about" element={<About />} />
          <Route path="/uses-by-grohit" element={<UsesByGRohit />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
          {/* Projects routing */}
          <Route path="/projects/weather-man" element={<Weatherman />} />
          <Route path="/projects/read-a-quote" element={<Quotes />} />
          <Route path="/projects/MovieDataBase" element={<MovieDB />} />
          <Route path="/projects/text-utilities" element={<TextUtils />} />
          {/* Error Page */}
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
